export const AUTHENTICATION_CHANGED_EVENT = "gamefik:authentication-changed";

export function notifyAuthenticationStateChanged(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(AUTHENTICATION_CHANGED_EVENT));
}
